angular.module('CarsSaraBo').factory('SitesService', ['$resource',
    function($resource) {
    return $resource('../rest/sites',
        {
            query: {method:'GET', isArray:true},
        }
    )}
]);



//////////////////
// WEBPACK FOOTER
// ./public/app/models/sites_service.js
// module id = 865
// module chunks = 3